const CVIcon = ({ size = 40 }) => (
  <svg
    width={size}
    height={(size * 19) / 14}
    viewBox="0 0 14 19"
    xmlns="http://www.w3.org/2000/svg"
    className="cv-icon"
    fill="currentColor"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M2.5 0.25C1.25898 0.25 0.25 1.25898 0.25 2.5V16C0.25 17.241 1.25898 18.25 2.5 18.25H11.5C12.741 18.25 13.75 17.241 13.75 16V5.875H9.25C8.62773 5.875 8.125 5.37227 8.125 4.75V0.25H2.5ZM9.25 0.25V4.75H13.75L9.25 0.25ZM4.1875 9.25H9.8125C10.1219 9.25 10.375 9.50313 10.375 9.8125C10.375 10.1219 10.1219 10.375 9.8125 10.375H4.1875C3.87812 10.375 3.625 10.1219 3.625 9.8125C3.625 9.50313 3.87812 9.25 4.1875 9.25ZM4.1875 11.5H9.8125C10.1219 11.5 10.375 11.7531 10.375 12.0625C10.375 12.3719 10.1219 12.625 9.8125 12.625H4.1875C3.87812 12.625 3.625 12.3719 3.625 12.0625C3.625 11.7531 3.87812 11.5 4.1875 11.5ZM4.1875 13.75H9.8125C10.1219 13.75 10.375 14.0031 10.375 14.3125C10.375 14.6219 10.1219 14.875 9.8125 14.875H4.1875C3.87812 14.875 3.625 14.6219 3.625 14.3125C3.625 14.0031 3.87812 13.75 4.1875 13.75Z"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0.25 0.25H13.75V18.25H0.25V0.25Z" />
      </clipPath>
    </defs>
  </svg>
);

export default CVIcon;
